import { useEffect, useState } from "react";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import StyledWrapper from "./style";
import LavorisService from "../../../services/LavorisService";
import moment from "moment";
import { useModal } from "../../../hooks";
import { InfoCard } from "../InfoCard/InfoCard";
import { TableActions } from "../../../components/others/TableActions";

type DetailTypes = {
  patient: any;
};
export default function AbsenteeismResultForm({ patient }: DetailTypes) {
  const LavorisInstance = LavorisService.getInstance();
  const { closeModal } = useModal();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!patient) return;
    setIsReady(true);
  }, [patient]);

  const fechaAlta = (fecha:string) => {
    let releaseDate: any = fecha;

    // Manejo de valores inválidos o nulos
    if (
      releaseDate === "*NO JUSTIFICADA*" ||
      releaseDate === "*NO VALIDA*" ||
      releaseDate === "00/00/0000" ||
      releaseDate === null
    ) {
      return "--";
    }

    // Si viene en formato DD/MM/YYYY
    const isEuropeanDateFormat = /^\d{2}\/\d{2}\/\d{4}$/.test(releaseDate);

    // Si viene en formato ISO
    const isISODate = /^\d{4}-\d{2}-\d{2}T.*Z$/.test(releaseDate);

    if (isEuropeanDateFormat) {
      return moment(releaseDate, "DD/MM/YYYY").format("DD/MM/YYYY");
    } else if (isISODate) {
      return moment(releaseDate).format("DD/MM/YYYY");
    }

    return "--";
  }


  if (!isReady)
    return (
      <h1 className="w-full flex justify-center text-red-500 font-bolder animate-pulse">
        {" "}
        Cargando...{" "}
      </h1>
    );
  return (
    <StyledWrapper.FormContainer>
      <InfoCard absentee={patient} />
      <div className="grid grid-cols-3 ml-1 gap-2">
        <StyledWrapper.Left className="font-bold">
          Modalidad:{" "}
        </StyledWrapper.Left>
        <StyledWrapper.Right>
          {patient?.report?.reportType || "N/A"}
        </StyledWrapper.Right>
        <StyledWrapper.Left>Solicitado por: </StyledWrapper.Left>
        <StyledWrapper.Right>{patient?.createdBy} </StyledWrapper.Right>
        <StyledWrapper.Left>Fecha </StyledWrapper.Left>
        <StyledWrapper.Right>
          {moment(patient?.createdDate).format("DD/MM/YYYY")}
        </StyledWrapper.Right>
        <StyledWrapper.Left>Diagnóstico presunto: </StyledWrapper.Left>
        <StyledWrapper.Right>
          {patient?.presumedDiagnosis || "N/A"}
        </StyledWrapper.Right>
        <StyledWrapper.Left>Certificado previo: </StyledWrapper.Left>
        <StyledWrapper.Right>
          {patient?.report?.presentsCertificate ? (
            <p>
              <b>Fecha:</b> {fechaAlta(patient.report.certificateDate)} <br />
              <b>Médico:</b> {patient.report.certificateProfessionalName} <br />
              <b>MAT.:</b> {patient.report.certificateProfessionalLicense}{" "}
              <br />
              <b>Cantidad de Días:</b> {patient.report.certificateJustifiedDays}
              {patient?.certificateId !== "Not Implemented" ? (
                <div className="flex ">
                  <TableActions
                    type="Download"
                    onClick={async () => {
                      await LavorisInstance.FilesService.getCertificateAWSFileById(
                        patient?.certificateId,
                      );
                    }}
                  />
                  {patient?.certificateUrl && (
                    <img
                      src={`${process.env.REACT_APP_AWS_CERTIFICATES}${patient?.certificateUrl}`}
                      className="w-64 ml-3"
                      alt=""
                    />
                  )}
                </div>
              ) : (
                <p className="italic">{"Sin archivo adjunto"}</p>
              )}
            </p>
          ) : (
            "No"
          )}
        </StyledWrapper.Right>
      </div>
      <StyledWrapper.Line />
      <h1 className="text-xl font-bold">Control Lavoris</h1>
      <div className="grid grid-cols-3 ml-1 gap-2">
        <StyledWrapper.Left>Diagnóstico</StyledWrapper.Left>
        <StyledWrapper.Right className="max-w-fit">
          {patient?.report?.diagnostic || "N/A"}
        </StyledWrapper.Right>
        <StyledWrapper.Left>Inasistencia justificada</StyledWrapper.Left>
        <StyledWrapper.Right>
          {patient?.report?.isAbsenceJustified ? "Si" : "No" || "N/A"}
        </StyledWrapper.Right>
        <StyledWrapper.Left>Fecha de alta</StyledWrapper.Left>
        <StyledWrapper.Right>
          {(patient?.report?.isAbsenceJustified && fechaAlta(patient?.report?.releaseDate)) || "--"}
        </StyledWrapper.Right>
        <StyledWrapper.Left>Profesional</StyledWrapper.Left>
        <StyledWrapper.Right>
          {patient?.specialist?.name || "N/A"} -{" "}
          {patient?.specialist?.licensePlate || "N/A"}
        </StyledWrapper.Right>
      </div>
      <StyledWrapper.Footer>
        <div
          className="h-100 cursor-pointer"
          onClick={() => closeModal("modalReporteAusentismo")}
        >
          <p>Volver</p>
        </div>
        {patient?.reportFileIdPatient && (
          <PrimaryButton
            type="button"
            onClick={async () => {
              await LavorisInstance.FilesService.getReportAWSFileById(
                patient?.reportFileIdPatient,
              );
            }}
            text="Descargar"
            styles="bg-red-500 font-bold text-white w-36"
          />
        )}
      </StyledWrapper.Footer>
    </StyledWrapper.FormContainer>
  );
}
